export default function LandingController($scope, $location, $state, $rootScope, IdentityMgmtService, localStorageService) {
	var self = this;
	$rootScope.unauthUser = false; //used in Initial Ctrl
	$rootScope.showSideMenu = false;

	$scope.$on('userInfo', function(ev, data){
		self.userInfo = data;
		IdentityMgmtService.getAuth(self.userInfo.email).then(function(resp){
			if(resp.data.isTeacher){
				$rootScope.showSideMenu = true;
				localStorageService.set('userIdent', resp.data);
				$state.go('olr.mainfe.dashboard');
			}
			else{
				$state.go('olr.mainfe.unauth');
				localStorageService.remove('userlgd');
				$rootScope.unauthUser = true;
			}	
		},
		function(err){
			$state.go('olr.mainfe.unauth');
			localStorageService.remove('userlgd');
			$rootScope.unauthUser = true;
		});
	});
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-landing/LandingController.js
 **/